import React from 'react';
import ArchiveImageFilter from './filters/ArchiveImageFilter';
import ArchiveYearRangeFilter from './filters/ArchiveYearRangeFilter';
import ArchiveBuildingTypeFilter from './filters/ArchiveBuildingTypeFilter';
import ArchivePersonFilter from './filters/ArchivePersonFilter';
import ArchiveCountyFilter from './filters/ArchiveCountyFilter';
import ArchiveDistrictFilter from './filters/ArchiveDistrictFilter';
import ArchiveParishFilter from './filters/ArchiveParishFilter';
import ArchiveLevelFilter from './filters/ArchiveLevelFilter';
import FormGroup from '../../components/FormGroup';

export default function ArchiveSearchFilters() {
  return (
    <>
      <FormGroup noBorder title="Images">
        <ArchiveImageFilter />
      </FormGroup>

      <FormGroup title="Date">
        <ArchiveYearRangeFilter />
      </FormGroup>

      <FormGroup title="Type">
        <ArchiveBuildingTypeFilter />
      </FormGroup>

      <FormGroup title="People and organisations">
        <ArchivePersonFilter />
      </FormGroup>

      <FormGroup title="Location">
        <ArchiveCountyFilter />
        <ArchiveDistrictFilter />
        <ArchiveParishFilter />
      </FormGroup>

      <FormGroup title="Collection">
        <ArchiveLevelFilter />
      </FormGroup>
    </>
  );
}
